import type { IconData } from '@stacksjs/iconify-core'

export const flashlightSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.913 2.007C14.3 1.755 18.16 1.5 24 1.5s9.699.255 12.087.507C38.75 2.29 40.5 4.551 40.5 7.064v2.155c-10.13-1.625-22.87-1.625-33 0V7.064c0-2.513 1.75-4.775 4.413-5.057M7.5 12.818v-.56c10.042-1.678 22.958-1.678 33 0v.56c0 1.326-.343 2.679-1.11 3.849a2 2 0 0 1-.105.14l-4.903 5.858c-.336 7.312-.886 14.982-1.182 18.88c-.165 2.174-1.66 4.175-4.02 4.557c-1.32.213-3.072.398-5.18.398s-3.86-.185-5.18-.398c-2.36-.382-3.855-2.383-4.02-4.556c-.296-3.9-.846-11.569-1.182-18.88l-4.903-5.859a2 2 0 0 1-.105-.14c-.767-1.17-1.11-2.523-1.11-3.849M26 28a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default flashlightSolid
